import { key } from 'Helpers/DiscountHelper'
import {
  Language_EN,
  Language_ES,
  Language_FR,
  Language_IT,
  DefaultOrderCategoryMarketplace,
  DefaultOrderCategoryWebsite,
  DefaultOrderCategoryLogistic,
  ExistingStock,
  AvailableStock,
  StockInitial,
  HockB2B,
  Ordered,
  Delivered,
  Unfilled,
  HockB2C,
  Purchased,
  Sellout,
  WithDrawn,
  InVision,
  Tailoring,
  Entries,
  HideQuantities,
  HideMarketplace,
  HideEdit,
  HideExtraFilters,
  HideOptionalFilters,
  HideWebAndMarketingFilters,
  HideAvailability,
  HideDimensionNearby,
  HideDimensionRemote,
  HideBarcodeElement,
  HideDimensionLocal,
  HideInterrogationType,
  HideWorkspaceDropdown,
  HidePredefinedFilters,
  HidenPriceFilters,
  HideUnlockMovementButton,
  HideFiltersNotActiveForQuantities,
  HideMovement,
  VariantModelValue,
  Exits,
  ReturnSupplier,
  Transit,
  ReturnCustomer,
  HidePrices,
  HideQuantityLimits,
  HideDiwaReactGridLayoutColumnsBtn,
  HidePIMIMages,
  Stores,
  ProfilesKeysType,
} from './Configuration'
import { ArticleColumn } from './TableConfiguration'

export enum WorkSpace {
  BACKOFFICE = 'Backoffice',
  STOREMANAGER = 'Store Manager',
  WEB = 'Web',
  OMNICHANNEL = 'Omnichannel',
  B2B = 'B2B',
  STORE = 'Store',
  MARKETPLACE = 'Marketplace',
  GRUCCIA = 'Gruccia',
  PIM = 'PIM',
  DEFAULT = 'Default',
}

export const WorkSpaces = {
  [WorkSpace.BACKOFFICE]: {
    language: '',
    quantitiesFilter: [
      ExistingStock,
      AvailableStock,
      StockInitial,
      HockB2B,
      Ordered,
      Delivered,
      Unfilled,
      HockB2C,
      Purchased,
      Sellout,
      WithDrawn,
      InVision,
      Tailoring,
    ],
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [ArticleColumn.ShortDescription, ArticleColumn.Description],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.CollectionType,
      ArticleColumn.Supplier,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.Color,
      ArticleColumn.Fabric,
      ArticleColumn.Size,
      ArticleColumn.Barcode,
      ArticleColumn.CountryOrigin,
      ArticleColumn.DetailedComposition,
      ArticleColumn.ShortDescription,
      ArticleColumn.Description,
      ArticleColumn.RetailPrice,
      ArticleColumn.WholesalePrice,
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: '',
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //listino 1, no listino 2
  },
  [WorkSpace.STOREMANAGER]: {
    language: '',
    quantitiesFilter: [
      ExistingStock,
      AvailableStock,
      Unfilled,
      Entries,
      Transit,
      Purchased,
      ReturnCustomer,
      WithDrawn,
      InVision,
      Tailoring,
    ],
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: { [Language_IT]: [], [Language_EN]: [], [Language_ES]: [], [Language_FR]: [] }, //nascosto
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.Color,
      ArticleColumn.Size,
      ArticleColumn.RetailPrice,
      ArticleColumn.DiscountedPrice,
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [
      HideMarketplace,
      HideExtraFilters,
      HideOptionalFilters,
      HideWebAndMarketingFilters,
      HideFiltersNotActiveForQuantities,
      HideQuantityLimits,
      HideEdit,
      HideAvailability,
      HidePrices,
    ],
    hiddenQuantitiesFilter: [StockInitial, HockB2B, Ordered, Delivered, Exits, ReturnSupplier, HockB2C, Sellout],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: true,
      priceList2: '',
    },
    //listino 1 e listino 2, 1 attivo
    //extra filter, campi opzionali, marketplace disattivati
    //prezzi: se prezzo acquisto(no) false ---> acquisto e acquisto lordo non visibile
    //modifica non disponibile
    //Griglia situazione filtri attivi – per quest’area gli altri flag NON possono essere comunque attivati  ??????

    //no tabella controllo disponibilità (solo movimenti)
    //no disponibilità (tabella marketplace)
  },
  [WorkSpace.WEB]: {
    language: '',
    quantitiesFilter: [ExistingStock], //nascosto
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [
        ArticleColumn.ShortDescription,
        ArticleColumn.SpecialDescription,
        ArticleColumn.Description,
        ArticleColumn.SizeAndFit,
      ],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.SuperColor,
      ArticleColumn.Color,
      ArticleColumn.Fabric,
      ArticleColumn.Pattern,
      ArticleColumn.Lifestyle,
      ArticleColumn.Size,
      ArticleColumn.CountryOrigin,
      ArticleColumn.DetailedComposition,
      ArticleColumn.ShortDescription,
      ArticleColumn.SpecialDescription,
      ArticleColumn.Description,
      ArticleColumn.SizeAndFit,
      ArticleColumn.RetailPrice,
      ArticleColumn.DiscountedPrice,
      'Sito1',
    ],
    activeStore: Stores.Remote,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [HideEdit, HideQuantities, HideOptionalFilters, HideUnlockMovementButton],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //no listino 2
    //no griglia quantità
    //no sblocca movimenti
  },
  [WorkSpace.OMNICHANNEL]: {
    language: '',
    quantitiesFilter: [ExistingStock], //nascosto
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [
        ArticleColumn.ShortDescription,
        ArticleColumn.SpecialDescription,
        ArticleColumn.Description,
        ArticleColumn.SizeAndFit,
      ],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.SuperColor,
      ArticleColumn.Color,
      ArticleColumn.Fabric,
      ArticleColumn.Pattern,
      ArticleColumn.Lifestyle,
      ArticleColumn.Size,
      ArticleColumn.CountryOrigin,
      ArticleColumn.DetailedComposition,
      ArticleColumn.ShortDescription,
      ArticleColumn.SpecialDescription,
      ArticleColumn.Description,
      ArticleColumn.SizeAndFit,
      ArticleColumn.RetailPrice,
      ArticleColumn.DiscountedPrice,
      'Sito1',
      'Adorelux',
      'Balaan',
      'Buyma',
      'Miinto',
      'Top 2 Fashion',
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [HideQuantities, HideOptionalFilters, HideUnlockMovementButton],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //no listino 2
    //no griglia quantità
    //no sblocca movimenti
  },
  [WorkSpace.B2B]: {
    language: '',
    quantitiesFilter: [
      ExistingStock,
      AvailableStock,
      StockInitial,
      HockB2B,
      Ordered,
      Delivered,
      Unfilled,
      ReturnSupplier,
      Purchased,
    ],
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [ArticleColumn.ShortDescription],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.CollectionType,
      ArticleColumn.Supplier,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.Color,
      ArticleColumn.Fabric,
      ArticleColumn.Size,
      ArticleColumn.Barcode,
      ArticleColumn.CountryOrigin,
      ArticleColumn.CustomsCode,
      ArticleColumn.DetailedComposition,
      ArticleColumn.ShortDescription,
      ArticleColumn.RetailPrice,
      ArticleColumn.WholesalePrice,
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //listino 1, no listino 2
  },
  [WorkSpace.STORE]: {
    language: '',
    quantitiesFilter: [ExistingStock, AvailableStock, WithDrawn, InVision, Tailoring],
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: { [Language_IT]: [], [Language_EN]: [], [Language_ES]: [], [Language_FR]: [] },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.SubCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.Color,
      ArticleColumn.Size,
      ArticleColumn.RetailPrice,
      ArticleColumn.DiscountedPrice,
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [
      HideAvailability,
      HideEdit,
      HideMarketplace,
      HideDimensionNearby,
      HideDimensionRemote,
      HideExtraFilters,
      HideOptionalFilters,
      HideFiltersNotActiveForQuantities,
      HideQuantityLimits,
      HideWebAndMarketingFilters,
      HidePrices,
    ],
    hiddenQuantitiesFilter: [
      StockInitial,
      HockB2B,
      Ordered,
      Delivered,
      Unfilled,
      Entries,
      Transit,
      Exits,
      ReturnSupplier,
      HockB2C,
      Purchased,
      Sellout,
      ReturnCustomer,
    ],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: true,
      priceList2: '',
    },
    //listino 1 e listino 2, 1 attivo
    //extra filter, campi opzionali, marketplace disattivati
    //prezzi: se prezzo acquisto(no) false ---> acquisto e acquisto lordo non visibile
    //modifica non disponibile
    //disponibile interrogazione solo per negozio locale
    //Griglia situazione filtri attivi – per quest’area gli altri flag NON possono essere comunque attivati  ??????

    //no griglia movimenti / controllo disponibilità
    //no disponibilità
  },
  [WorkSpace.MARKETPLACE]: {
    language: '',
    quantitiesFilter: [ExistingStock], //nascosto
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [
        ArticleColumn.ShortDescription,
        ArticleColumn.SpecialDescription,
        ArticleColumn.Description,
        ArticleColumn.SizeAndFit,
      ],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.Color,
      ArticleColumn.Size,
      ArticleColumn.ShortDescription,
      ArticleColumn.SpecialDescription,
      ArticleColumn.Description,
      ArticleColumn.SizeAndFit,
      ArticleColumn.RetailPrice,
      ArticleColumn.DiscountedPrice,
      'Adorelux',
      'Balaan',
      'Buyma',
      'Miinto',
      'Top 2 Fashion',
    ],
    activeStore: Stores.Remote,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [HideQuantities, HideOptionalFilters, HideUnlockMovementButton],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //no listino 2
    //no griglia quantità
    //sblocca moviementi NO
  },
  [WorkSpace.GRUCCIA]: {
    language: '',
    quantitiesFilter: [AvailableStock],
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: { [Language_IT]: [], [Language_EN]: [], [Language_ES]: [], [Language_FR]: [] },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.SubCategory,
      ArticleColumn.Department,
      ArticleColumn.Color,
    ],
    activeStore: Stores.Local,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [
      HideMovement,
      HideAvailability,
      HideMarketplace,
      HideEdit,
      HideBarcodeElement,
      HideDimensionLocal,
      HideDimensionNearby,
      HideDimensionRemote,
      HideInterrogationType,
      HideWorkspaceDropdown,
      HidePredefinedFilters,
      HideExtraFilters,
      HidenPriceFilters,
      HideOptionalFilters,
      HideMarketplace,
      HidePrices,
      HideQuantityLimits,
      HideUnlockMovementButton,
      HideDiwaReactGridLayoutColumnsBtn,
      HidePIMIMages,
    ],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: true,
      priceList2: '',
    },
  },
  [WorkSpace.PIM]: {
    language: '',
    quantitiesFilter: [ExistingStock], //nascosto
    marketplaceCategorySort: [
      DefaultOrderCategoryMarketplace,
      DefaultOrderCategoryWebsite,
      DefaultOrderCategoryLogistic,
    ],
    extraDescriptionLangOptions: {
      [Language_IT]: [
        ArticleColumn.ShortDescription,
        ArticleColumn.SpecialDescription,
        ArticleColumn.Description,
        ArticleColumn.SizeAndFit,
      ],
      [Language_EN]: [],
      [Language_ES]: [],
      [Language_FR]: [],
    },
    emptyExtraDescriptions: [],
    availabilitiesFilter: [],
    negateTableColumns: [],
    activeFilters: [
      ArticleColumn.ArticleCode,
      ArticleColumn.Season,
      ArticleColumn.Brand,
      ArticleColumn.Category,
      ArticleColumn.SubCategory,
      ArticleColumn.SuperCategory,
      ArticleColumn.Department,
      ArticleColumn.ProductDescription,
      ArticleColumn.SuperColor,
      ArticleColumn.Color,
      ArticleColumn.Fabric,
      ArticleColumn.Pattern,
      ArticleColumn.Lifestyle,
      ArticleColumn.Size,
      ArticleColumn.CountryOrigin,
      ArticleColumn.DetailedComposition,
      ArticleColumn.ShortDescription,
      ArticleColumn.SpecialDescription,
      ArticleColumn.Description,
      ArticleColumn.SizeAndFit,
    ],
    activeStore: Stores.Remote,
    emptyTableOptions: [],
    filterSearch: 'all',
    hiddenElements: [HideEdit, HideQuantities, HideOptionalFilters, HideUnlockMovementButton, HidenPriceFilters],
    hiddenQuantitiesFilter: [],
    pricelists: {
      priceList1Enabled: true,
      priceList1Visible: true,
      priceList1: VariantModelValue,
      priceList2Enabled: false,
      priceList2Visible: false,
      priceList2: '',
    },
    //no listino 2
    //no griglia quantità
    //no sblocca movimenti
  },
}

export type ProfileWorkspace = { [key in ProfilesKeysType]: WorkSpace[] }
export const ProfileWorkspaceMapping: ProfileWorkspace = {
  ShopProfile: [WorkSpace.STOREMANAGER, WorkSpace.STORE],
  MpWebProfile: [WorkSpace.OMNICHANNEL, WorkSpace.MARKETPLACE, WorkSpace.WEB, WorkSpace.PIM],
  WebAgencyProfile: [WorkSpace.WEB, WorkSpace.MARKETPLACE, WorkSpace.OMNICHANNEL, WorkSpace.PIM],
  BkProfile: [
    WorkSpace.BACKOFFICE,
    WorkSpace.MARKETPLACE,
    WorkSpace.OMNICHANNEL,
    WorkSpace.WEB,
    WorkSpace.B2B,
    WorkSpace.PIM,
  ],
  SuperProfile: [],
  PimProfile: [WorkSpace.PIM],
}

export const getDefaultWorkspace = (key: ProfilesKeysType): WorkSpace => {
  switch (key) {
    case 'BkProfile':
      return WorkSpace.BACKOFFICE
    case 'SuperProfile':
      return WorkSpace.BACKOFFICE
    case 'MpWebProfile':
      return WorkSpace.OMNICHANNEL
    case 'PimProfile':
      return WorkSpace.PIM
    case 'ShopProfile':
      return WorkSpace.STOREMANAGER
    case 'WebAgencyProfile':
      return WorkSpace.OMNICHANNEL
  }
}

// export const ProfileWorkspaceMapping  = {
//   [ShopProfile]: [WorkSpace.STOREMANAGER, WorkSpace.STORE],
//   [MpWebProfile]: [WorkSpace.OMNICHANNEL, WorkSpace.MARKETPLACE, WorkSpace.WEB, WorkSpace.PIM],
//   [WebAgencyProfile]: [WorkSpace.MARKETPLACE, WorkSpace.OMNICHANNEL, WorkSpace.WEB, WorkSpace.PIM], // o solo web?
//   [BkProfile]: [
//     WorkSpace.BACKOFFICE,
//     WorkSpace.MARKETPLACE,
//     WorkSpace.OMNICHANNEL,
//     WorkSpace.WEB,
//     WorkSpace.B2B,
//     WorkSpace.PIM,
//   ],
//   [SuperProfile]: [] as WorkSpace[],
//   [PimProfile]: [WorkSpace.PIM],
// }
